module.exports = __webpack_public_path__ + "img/16l011-07.41536f8b.png";